import { CaretDownOutlined } from '@vindr/icons';
import { useGetInstitutions } from '@vindr/services/actions/institution.action';
import { Input, InputRef, Select } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import { ComponentProps, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import DateRangePicker, { extendDateOptions } from '@vindr/ui/src/components/ui/DateRangePicker';
import { FILTER_TYPE } from './constants';

const useSearchOptions = (params, handleOnChangeFilter) => {
  const { t } = useTranslation('Vindoc');
  const institutions = useGetInstitutions({ offset: 0, limit: 100 })?.data?.data || [];
  const [open, setOpen] = useState(false);

  const InputItem = (
    params,
    key,
    placeholder = t('Keyword'),
    props?: ComponentProps<typeof Input>
  ) => {
    const inputRef = useRef<InputRef>(null);

    /* useEffect(() => {
      if (inputRef.current && props?.autoFocus === true) {
        //? Trick for focus when first render component
        setTimeout(() => inputRef.current.focus(), 0);
      }
    }, [props?.autoFocus]); */

    return (
      <Input
        ref={inputRef}
        size="small"
        className="w-[200px] max-w-full"
        value={params[key]}
        placeholder={placeholder}
        onChange={(event) => handleOnChangeFilter(params, key, event?.target?.value)}
        onPressEnter={(event) => handleOnChangeFilter(params, key, event?.target?.value, true)}
        {...props}
        // {...(props?.autoFocus && { autoFocus: true })}
      />
    );
  };

  return [
    {
      text: t('Scheduled Date'),
      key: FILTER_TYPE.SCHEDULED_DATE,
      component: (
        <DateRangePicker
          size="small"
          value={[
            params.scheduled_date_from
              ? dayjs(params.scheduled_date_from)
              : extendDateOptions['Last 7 days'][0],
            params.scheduled_date_to
              ? dayjs(params.scheduled_date_to)
              : extendDateOptions['Last 7 days'][1],
          ]}
          onChange={(values: Dayjs[]) => {
            handleOnChangeFilter(
              params,
              FILTER_TYPE.SCHEDULED_DATE,
              [values[0].startOf('days'), values[1].endOf('days')],
              true
            );
          }}
          disabledDate={() => false}
        />
      ),
    },
    {
      text: t('Patient Name'),
      key: FILTER_TYPE.PATIENT_NAME,
      component: InputItem(params, FILTER_TYPE.PATIENT_NAME, t('Enter Patient Name')),
    },
    {
      text: t('Order Group'),
      key: FILTER_TYPE.ORDER_GROUP,
      component: InputItem(params, FILTER_TYPE.ORDER_GROUP, t('Enter Order Group')),
    },
    {
      text: t('Visit ID'),
      key: FILTER_TYPE.VISIT_ID,
      component: InputItem(params, FILTER_TYPE.VISIT_ID, t('Enter Visit ID')),
    },
    {
      text: t('Institution'),
      key: FILTER_TYPE.INSTITUTION,
      component: (
        <Select
          size="small"
          mode="multiple"
          open={open}
          onDropdownVisibleChange={(visible) => setOpen(visible)}
          allowClear
          disabled
          maxTagCount="responsive"
          suffixIcon={<CaretDownOutlined />}
          placeholder={t('Select Institution')}
          className="select-dropdown-light w-40"
          popupClassName="dropdown-options-dark"
          onChange={(value) => {
            if (window.innerWidth < 640) {
              setOpen(false);
            }
            handleOnChangeFilter(params, FILTER_TYPE.INSTITUTION, value, true);
          }}
          value={params[FILTER_TYPE.INSTITUTION] || []}
          filterOption={(input, option) =>
            (option.children as unknown as string).toLowerCase().includes(input.toLowerCase()) ||
            option.key.toLowerCase().includes(input.toLowerCase())
          }
        >
          {institutions
            ? institutions.map((it, idx) => (
                <Select.Option key={idx} value={it?.id}>
                  {it?.name}
                </Select.Option>
              ))
            : null}
        </Select>
      ),
    },
    {
      text: t('Patient ID'),
      key: FILTER_TYPE.PATIENT_ID,
      component: InputItem(params, FILTER_TYPE.PATIENT_ID, t('Enter Patient ID'), {
        // autoFocus: true,
      }),
    },
  ];
};

export default useSearchOptions;
